import { useStorage } from '@vueuse/core'
import { defineStore } from 'pinia'
import { ref } from 'vue'

/*
	Changes:
	AJL-11-06-25: Changed to Composition API, cleaned up uses of store, added getters/actions, comments
 */

/**
 * @typedef {function} signupStore
 * @property {Object} state - signupStore state
 * @property {string} state.userOrganization - User's Organization as JSON string
 * @property {string} state.loginToastMessage - Toast message
 */

export const useSignupStore = defineStore('signupStore', {
	state: () => ({
		userOrganization: useStorage('userOrganization', ref(null)),
		loginToastMessage: useStorage('loginToastMessage', ref(null))
	}),
	getters: {
		/**
		 * Gets the user's organization
		 * @param {signupStore.state} state
		 * @returns {string} JSON string of user organization data
		 */
		getUserOrganization(state) {
			return state.userOrganization ? JSON.parse(state.userOrganization) : null
		},

		/**
		 * Gets the Login toast message
		 * @param {signupStore.state} state
		 * @returns {string | null}
		 */
		getLoginToastMessage(state) {
			return state.loginToastMessage
		},
	},
	actions: {
		logout() {
			this.userOrganization = null
		},

		/**
		 * Set the login message
		 * @param {string | null} p_message Message to show or null
		 */
		setLoginToastMessage(p_message)
		{
			this.loginToastMessage = typeof p_message === 'string' && p_message.length > 0 ? p_message : null;
		},

		/**
		 * Set the login message
		 * @param {string} p_organization JSON string of user organization data
		 */
		setUserOrganization(p_organization)
		{
			if (typeof p_organization === 'string')
			{
				this.userOrganization = p_organization
			}
			else if (typeof p_organization === 'object')
			{
				this.userOrganization = JSON.stringify(p_organization)
			}
			else
			{
				this.userOrganization = null
			}
		}
	},
})